import { Link } from 'react-router';
import styled from 'styled-components';

export const Wrapper = styled.div<{ $backgroundImage: string }>`
	width: 100%;
	border-radius: 12px;
	background-color: ${({ theme }) => theme.colors.background.secondary};
	background-image: ${({ $backgroundImage }) => `url('${$backgroundImage}')`};
	background-repeat: no-repeat;
	background-size: cover;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px;
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light15};
`;

export const IdLabel = styled.div`
	font-size: 20px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.subtitle};
	margin: 0;
	display: flex;
	align-items: center;
	gap: 4px;
	cursor: pointer;
`;

export const Id = styled.span`
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
`;

export const Logout = styled.div`
	svg {
		fill: ${({ theme }) => theme.colors.icon.alwaysWhite};
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	justify-content: center;
	padding: 36px 16px;
`;

export const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.colors.text.subtitle};

		rect {
			fill: ${({ theme }) => theme.colors.text.subtitle};
		}
	}
`;

export const SkinPlaceLink = styled(Link)`
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		width: 20px;
		height: 20px;
	}
`;

export const Name = styled.div<{ $isClickable?: boolean }>`
	margin: 0;
	font-size: 16px;
	color: ${({ theme }) => theme.colors.text.subtitle};
	font-weight: 400;
	display: inline-flex;
	align-items: center;
	gap: 6px;

	cursor: ${({ $isClickable }) => $isClickable && 'pointer'};
`;

export const Value = styled.span`
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
`;

export const Copy = styled.div`
	svg {
		fill: ${({ theme }) => theme.colors.icon.chevron};
	}
`;
